import { Component, Input } from '@angular/core';
import { ErrorNotificationsService } from '../error-handling/error-notifications.service';

@Component({
    selector: 'app-alerts-container',
    template: `
    <div class="toast-container position-fixed p-3 z-top" [ngClass]="positionClass">
      <ngb-toast *ngFor="let error of errorsService.errors"
                 class="bg-danger text-light"
                 [autohide]="error.autoHide"
                 [delay]="error.autoHideDuration"
                 (hidden)="errorsService.hide(error)">
        <div class="d-flex justify-content-between">
          <span>{{error.time}}</span>
          <div>
            <button class="btn-close btn-close-white" aria-label="Close" (click)="errorsService.hide(error)"></button>
          </div>
        </div>

        <div class="text-pre-wrap">{{error.message}}</div>
      </ngb-toast>
    </div>
  `,
    styles: [`
    .z-top {
      z-index: 2500;
    }

    .text-pre-wrap {
      white-space: pre-wrap;
    }

    /* CSS specific to iOS devices */ 
    @supports (-webkit-touch-callout: none) {
      .toast-container {
        padding-top: 3rem !important;
      }
    }
  `],
    standalone: false
})

export class AlertsContainerComponent {
  @Input() position: 'top-end' | 'top-center' = 'top-end';

  get positionClass(): string[] | string {
    if (this.position === 'top-center') {
      return ['top-0', 'start-50', 'translate-middle-x'];
    }

    return ['top-0', 'end-0'];
  }

  constructor(public errorsService: ErrorNotificationsService) {
  }
}
